module.exports = __webpack_public_path__ + "img/shakepay.dfdc9c1e.svg";